import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';


const carouselContentTagName = 'slide';
let counter = 1;

// For static carousel
register('wm-carousel-content', (): IBuildTaskDef => {
  return {
    pre: attrs => `<${carouselContentTagName} wm-droppable=true wmsTransclude wmCarouselTemplate ${getAttrMarkup(attrs)}>`,
    post: () => `</${carouselContentTagName}>`
  };
});

// For dynamic carousel
register('wm-carousel-template', (): IBuildTaskDef => {
    return {
      pre: attrs => `<div class="app-carousel-item item"  wm-droppable=true wmsTransclude wmCarouselTemplate ${getAttrMarkup(attrs)}>`,
      post: () => `</div>`
    };
});



export default () => {};
